export default __webpack_public_path__ + "static/media/spr-motion.d0f8ead1.mp4";